export enum JobPhaseBumpApprovalStatus {
  MISMATCH_APPROVAL = 'MISMATCH_APPROVAL',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  PENDING_REVIEW = 'PENDING_REVIEW',
  NOT_STARTED = 'NOT_STARTED',
  APPROVED = 'APPROVED',
  OVERRIDDEN = 'OVERRIDDEN',
  DEPRECATED = 'DEPRECATED',
}
